/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */

import Promise from 'bluebird';
import $ from 'jquery';
import _ from 'underscore';
import { getBrandGridFactory } from '@bingads-webui-campaign/cpg-product-feed-grid';
import { getRouterDep } from '@bingads-webui-campaign-react/legacy-router-dep';
import { getGridPreferences } from '@bingads-webui-campaign/summary-grid-helper';
import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import appState from '@bingads-webui-component-legacy/state/index';
import segmentTimeChecker from '@bingads-webui-component-legacy/bingads-grid/shared/timeRangeChecker';
import { fetchPaginationConfig } from '@bingads-webui-component-legacy/bingads-grid/service/fetch-pagination';

import { brandGridLegacyDepsList } from './legacy-deps-list';
import { getAdditionalPluginsFactory } from './additional-plugins';


let brandFactory = null;
const brandPromiseFactory = () => {
  const brandPromise = new Promise((resolve) => {
    if (brandFactory) {
      resolve(brandFactory);
    } else {
      getBrandGridFactory()(brandGridLegacyDepsList)
        .then((result) => {
          brandFactory = result;
          resolve(result);
        });
    }
  });
  return brandPromise;
};

export function createBrandsGridForUiNext({
  serverContext,
  toolbarPlugin,
  preferenceService,
  scope,
  permissions,
  currentCampaign,
  currentAdGroup,
  siteMap,
  perfMarker,
  fetchDataCallback,
  hideSubBrand,
}) {
  return new Promise((resolve) => {
    const campaignContext = {
      currentCampaign,
      currentAdGroup,
    };
    brandPromiseFactory({
      serverContext,
      scope,
      permissions,
      campaignContext,
      preferenceService,
    }).then(({ createBrandGrid }) => {
      const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/product-feed');

      // merge the scopeService instance and scope entity object together
      const scopeAdapter = _.extend({
        customerId: scope.values.cid,
        accountId: scope.values.aid,
        campaignId: scope.values.campaignId,
        adGroupId: scope.values.adGroupId,
      }, scope);

      if (scopeAdapter.adGroupId) {
        appState.set('campaign_id', scopeAdapter.campaignId);
        appState.set('adgroup_id', scopeAdapter.adGroupId);
      } else if (scopeAdapter.campaignId) {
        appState.set('campaign_id', scopeAdapter.campaignId);
        appState.unset('adgroup_id');
      } else {
        appState.unset('campaign_id');
        appState.unset('adgroup_id');
      }

      let edmEntity = edm.currentAccount;
      if (scopeAdapter.adGroupId) {
        edmEntity = edm.currentAdGroup;
      } else if (scopeAdapter.campaignId) {
        edmEntity = edm.currentCampaign;
      }

      const router = {
        getRouteTo: () => 'route',
        navigateToRoute: getRouterDep(scope, siteMap).navigateToRoute,
      };
      const $viewport = $('.brand-page');

      getGridPreferences({
        gridName: 'productsGrid',
        dateUtil: {
          format: value => i18n.formatDate(value),
        },
        state: appState,
        edm: edmEntity,
        segmentTimeChecker,
        fetchPaginationConfig,
        customColumnsEnabled: false,
      }).then((preferenceConfig) => {
        resolve({
          gridView: createBrandGrid({
            getAdditionalPlugins: getAdditionalPluginsFactory({
              toolbarPlugin,
              scope: scopeAdapter,
              i18n,
            }),
            preferenceConfig,
            router,
            scope: scopeAdapter,
            addDateChangeListener: _.noop,
            isForVNext: true,
            viewport: $viewport,
            customHeaderOffset: () => $viewport.find('.sticky-container').height(),
            perfMarker,
            fetchDataCallback,
            hideSubBrand,
          }),
          i18n,
        });
      });
    });
  });
}
